import { Link } from 'react-router'
import { useLocale } from '../../content'
import { pathFor } from '../../routes'

/**
 * Closing call to action: forest band, heading + optional line, one button to
 * the contact page. Band text uses `on-forest` (cream in both themes); the
 * secondary line stays at 95 %. The pill is `cta-fg` on `cta` text (cream on
 * forest in light, forest-dark on cream in dark — inverted against the band);
 * in dark the forest-dark pill sits on the forest band with almost no edge, so
 * the ring draws one.
 */
export function CtaBand({ title, text, ctaLabel }: { title: string; text?: string; ctaLabel: string }) {
  const locale = useLocale()
  return (
    <section className="bg-vc2-forest text-vc2-on-forest">
      <div className="vc2-container flex flex-col justify-between gap-6 py-16 md:flex-row md:items-center md:py-20">
        <div>
          <h2 className="vc2-display text-3xl md:text-4xl">{title}</h2>
          {text && <p className="mt-3 max-w-xl text-vc2-on-forest/95">{text}</p>}
        </div>
        <Link
          to={pathFor('contatti', locale)}
          className="self-start rounded-full bg-vc2-cta-fg px-7 py-3 ring-1 ring-vc2-on-forest/70 text-xs font-semibold uppercase tracking-[0.16em] text-vc2-cta transition-opacity hover:opacity-90 md:self-auto"
        >
          {ctaLabel}
        </Link>
      </div>
    </section>
  )
}
